// extracted by mini-css-extract-plugin
export var need = "need-module--need--1ORMQ";
export var need__wrap = "need-module--need__wrap--1MRSO";
export var need__content = "need-module--need__content--1wpwn";
export var need__boxes = "need-module--need__boxes--1cL9T";
export var need__boxes__box = "need-module--need__boxes__box--2BGbs";
export var need__boxes__box__image = "need-module--need__boxes__box__image--2J6d7";
export var need__links = "need-module--need__links--equQm";
export var need__links__bg = "need-module--need__links__bg--2Svdn";
export var need__links__content = "need-module--need__links__content--1VfqX";